import React from "react";
import { Search } from "lucide-react";
import { MultiSelect } from "../MultiSelect";
import { STATUS_OPTS, INV_TYPES } from "./shared";

const ctl = "h-10 px-2 rounded-md border border-input bg-card text-sm focus:outline-none focus:ring-2 focus:ring-ring/40";

export const EMPTY_FILTERS = { search: "", start: "", end: "", source: "all", statuses: [], parties: [], types: [], accounts: [] };

const isFiltered = (f) => f.search || f.start || f.end || f.source !== "all" || f.statuses.length || f.parties.length || f.types.length || f.accounts.length;

const Labeled = ({ title, children }) => (
  <div>
    <div className="text-[11px] text-muted-foreground mb-0.5">{title}</div>
    {children}
  </div>
);

export const InvoiceFilters = ({ filters, setFilters, partyOpts, accountOpts }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const setInput = (k) => (e) => set(k)(e.target.value);
  return (
    <>
      <div className="flex flex-wrap items-end gap-3 mb-5">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input data-testid="invoice-search" value={filters.search} onChange={setInput("search")}
            placeholder="Search by invoice no, account, vehicle or driver mobile…"
            className="w-full h-10 pl-9 pr-3 rounded-md border border-input bg-card text-sm focus:outline-none focus:ring-2 focus:ring-ring/40" />
        </div>
        <Labeled title="From"><input data-testid="invoice-start" type="date" value={filters.start} onChange={setInput("start")} className={`${ctl} num`} /></Labeled>
        <Labeled title="To"><input data-testid="invoice-end" type="date" value={filters.end} onChange={setInput("end")} className={`${ctl} num`} /></Labeled>
        <Labeled title="Source">
          <select data-testid="invoice-source-filter" value={filters.source} onChange={setInput("source")} className={ctl}>
            <option value="all">All sources</option>
            <option value="tata_motors">Tata Motors</option>
            <option value="outside">Outside</option>
          </select>
        </Labeled>
        {isFiltered(filters) ? (
          <button data-testid="invoice-clear-filters" onClick={() => setFilters(EMPTY_FILTERS)}
            className="h-10 px-3 rounded-md border border-input bg-card text-xs hover:bg-muted transition-colors">Clear</button>
        ) : null}
      </div>
      <div className="flex flex-wrap items-end gap-3 mb-5">
        <MultiSelect label="Status" testid="inv-status-filter" options={STATUS_OPTS} selected={filters.statuses} onChange={set("statuses")} placeholder="All statuses" />
        <MultiSelect label="Types" testid="inv-type-filter" options={INV_TYPES} selected={filters.types} onChange={set("types")} placeholder="All types" />
        <MultiSelect label="Account" testid="inv-account-filter" options={accountOpts} selected={filters.accounts} onChange={set("accounts")} placeholder="All accounts" />
      </div>
    </>
  );
};

export const filtersToParams = (f) => {
  const params = {};
  if (f.statuses.length) params.statuses = f.statuses.join(",");
  if (f.parties.length) params.parties = f.parties.join(",");
  if (f.types.length) params.types = f.types.join(",");
  if (f.accounts.length) params.accounts = f.accounts.join(",");
  if (f.source !== "all") params.source = f.source;
  if (f.search.trim()) params.search = f.search.trim();
  if (f.start) params.start = f.start;
  if (f.end) params.end = f.end;
  return params;
};
